import { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

import { PostFields, postGQLFields } from './posts.fields.js'

export function getMemberPostsGQLQuery(fields: PostFields): DocumentNode {
  return gql`
    query getMemberPost(
      $after: String
      $before: String
      $hasParent: Boolean
      $limit: Int!
      $memberId: ID!
      $offset: Int
      $reverse: Boolean
    ) {
      memberPosts(
        after: $after
        before: $before
        hasParent: $hasParent
        limit: $limit
        memberId: $memberId
        offset: $offset
        reverse: $reverse
      ) {
        edges {
          cursor
          node {
            ${postGQLFields(fields)}
          }
        }
        nodes {
          ${postGQLFields(fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  `
}
